import $ from 'jquery';
import JTB from 'jquery-throttle-debounce';

$.throttle = JTB.Cowboy.throttle;
$.debounce = JTB.Cowboy.debounce;
